const baseUrl = process.env.REACT_APP_baseUrl;
const socketUrl = process.env.REACT_APP_SOCKET_IO_URL;
const imageUrl = process.env.REACT_APP_IMAGE_URL;
const fxUrl = process.env.REACT_APP_fxUrl;
export { baseUrl, socketUrl, imageUrl,fxUrl };
